/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'unicon-note-field',
  templateUrl: './note-field.component.html',
  styleUrl: './note-field.component.scss',
})
export class NoteFieldComponent {
  @Input() value!: string;
  @Input() title!: string;
  @Input() loading: boolean = false;
  @Input() editNote$!: BehaviorSubject<boolean>;
  editNote: boolean = false;
  @Output() result: EventEmitter<any> = new EventEmitter<string>();
  protected form!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private cdRef: ChangeDetectorRef,
  ) {
    this.setForm();
  }

  ngOnInit(): void {
    this.setInitialValue();
    this.editNote$.subscribe(value => {
      this.editNote = value;
      this.cdRef.detectChanges();
    });
  }

  private setInitialValue(): void {
    if (this.value && this.value.length > 0) {
      this.form.controls['textarea'].setValue(this.value);
    }
  }

  private setForm(): void {
    this.form = this.formBuilder.group({
      textarea: new FormControl<string>({ disabled: false, value: '' }),
    });
  }

  protected onSubmit(): void {
    this.form.controls['textarea'].disable();
    this.result.emit(this.form.controls['textarea']);
  }

  protected onFocusTextarea() {
    this.editNote = true;
  }
}
